export default "__VITE_ASSET__COa28L4i__"